<template>
  <el-upload
      :show-file-list="false"
      :auto-upload="true"
      action="https://plus.escroud.com"
      :http-request="requestHandle"
      :before-upload="beforeUpload"
      v-loading="uploadLoading"
      class="rounded-2xl border-[#E0E0E0] border-[1px] border-solid relative inset-0"
      :style="{width: width + 'px', height: height + 'px'}"
  >
    <div v-if="value" class="container_size group rounded-2xl" :style="{width: width + 'px', height: height + 'px'}" @click.stop>
      <el-image
          ref="preview"
          class="container_size block absolute inset-0 rounded-2xl"
          :src="value"
          alt=""
          fit="cover"
          :preview-src-list="[value]"
      />
      <div class="icon_box hidden group-hover:block">
        <div class="flex">
          <span @click="deleteHandle">
            <img src="../assets/ads/delete@2x.png" alt=""/>
            <span>Delete</span>
          </span>
            <span @click="replaceHandle">
            <img src="../assets/ads/replace@2x.png" alt=""/>
            <span>Replace</span>
          </span>
            <span @click="viewHandle">
            <img src="../assets/ads/view@2x.png" alt=""/>
            <span>View</span>
          </span>
        </div>
      </div>
    </div>
    <div v-else class="flex justify-center items-center flex-col" :style="{width: width + 'px', height: height + 'px'}">
      <img class="w-8 h-8" src="../assets/picture@2x.png" alt=""/>
      <span class="mt-2 text-[12px] font-normal leading-[18px]">Upload</span>
    </div>
  </el-upload>
</template>

<script>
import {Axios} from '@/axios/axios'
export default {
  name: 'RaImgUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default:0
    },
    uploadApiPath: {
      type: String,
      required: true, // 如果该属性是必需的，请设置为true
    },
    type:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      uploadLoading: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
    }
  },
  methods: {
    beforeUpload(file) {
      const imgFileType = ['image/gif', 'image/jpeg', 'image/jpg', 'image/jpeg', 'image/x-png', 'image/png']

      if (!imgFileType.includes(file.type)) {
        this.$message({type: 'error', message: 'Upload pictures only！'})
        return false
      }
      // 使用 FileReader 读取文件
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          const width = img.width;
          const height = img.height;
          let size = width + '*'+ height
          this.$emit('outSizeHandle',size)
        };

        img.onerror = () => {
          this.$message({type: 'error', message: 'Invalid image file!'});
          return false; // 文件不符合要求，阻止上传
        };
      }
    },
    async requestHandle(e) {
      const formData = new FormData();
      formData.append('file', e.file);
      if (this.type){
        formData.append('type', this.type);
      }
      try {
        this.uploadLoading = true;

        // 使用传入的API路径动态构建请求
        const response = await Axios.post(this.uploadApiPath, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            "token":localStorage.getItem('token')
          },
        });

        this.uploadLoading = false;
        if (response.code === 200) {
          console.log(response.data,'ddd')
          this.$emit('input', this.baseUrl + response.data.url); // 假设返回的结构与之前相同
          this.$message({
            type: "success",
            message: "Upload success",
          });
        } else {
          this.$message.error("Upload failed.");
        }
      } catch (error) {
        this.uploadLoading = false;
        console.error("Upload error:", error);
        this.$message.error("Upload failed.");
      }
    },
    // requestHandle(e) {
    //   const formData = new FormData()
    //   formData.append('file', e.file)
    //   this.uploadLoading = true
    //   uploadImg(formData).then(res => {
    //     this.uploadLoading = false
    //     if (res.code === 200) {
    //       this.$emit('input', this.baseUrl + res.data.url)
    //       this.$message({
    //         type: "success",
    //         message: "upload success"
    //       })
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //   })
    // },
    deleteHandle(e) {
      // 删除图片的逻辑
      this.$emit('input', '')
      e.stopPropagation()
    },
    replaceHandle() {
      // 替换图片的逻辑
      this.$emit('input', '')
    },
    viewHandle(e) {
      // 查看图片的逻辑
      e.stopPropagation()
      this.$refs.preview.clickHandler()
    }
  }
}
</script>
<style lang="less" scoped>
.container_size {
  img {
    border-radius: 16px;
  }
}

.icon_box {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #FFFFFF;
  font-size: 12px;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  >div{
    justify-content: space-between;
    align-items: center;
    width: 181px;
    margin: 0 auto;
    height: 100%;
    .container_size();
    border-radius: 16px;

    & > span {
      height: 38px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }
}

/deep/ .el-upload {
  width: 100%;
  height: 100%;

  img {
    //border-radius: 16px;
  }

  .el-image__error {
    border-radius: 16px;
  }
}
/deep/ .el-loading-mask{
  border-radius: 16px;
}
</style>
